module.exports = __webpack_public_path__ + "img/bar.f837a4bc.svg";